import {
  useV4GetRetailersQuery,
  type V4GetRetailersQueryVariables,
  type V4GetRetailersQuery,
} from '../../__codegen__/api'

interface UseV4GetRetailersResult {
  retailers: V4GetRetailersQuery['instacart_customers_partners_v1_PartnersService_GetRetailers']['retailers']
  loading: boolean
  error: Error
}

export const useV4GetRetailers = (
  params: V4GetRetailersQueryVariables
): UseV4GetRetailersResult => {
  const { data, previousData, loading, error } = useV4GetRetailersQuery({
    variables: params,
    skip: !params.ids?.length && !params.name,
  })

  return {
    retailers: (data || previousData)?.instacart_customers_partners_v1_PartnersService_GetRetailers
      ?.retailers,
    loading,
    error,
  }
}
